import { NgIf } from "@angular/common";
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { KursanmeldungApiService, KursInfoTeilnehmerVO, KursInfoVO, TeilnehmerApiService, TeilnehmerVO } from '@core/api/v1';
import { kursTitelMap } from "@core/model/kursTitel";
import { zertifizierungstyp } from "@core/model/optionen/zertifizierungstyp";
import { CheckboxModule } from "primeng/checkbox";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { ListboxModule } from "primeng/listbox";
import { gutachterTaetigkeitOptionen } from "@core/model/optionen/gutachterTaetigkeit";
import ZertifizierungstypEnum = KursInfoTeilnehmerVO.ZertifizierungstypEnum;
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import TypEnum = KursInfoVO.TypEnum;

@Component({
    selector: 'app-kurs-anmeldung',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        ListboxModule,
        InputTextModule,
        DialogModule,
        CheckboxModule,
        NgIf,
        FaIconComponent,
        RouterLink,
    ],
    templateUrl: './kurs-anmeldung.component.html',
    styleUrl: './kurs-anmeldung.component.scss',
})
export class KursAnmeldungComponent {
    @Output() hideAnmeldenBtn = new EventEmitter<KursInfoVO>();
    protected readonly gutachterTaetigkeitOptionen = gutachterTaetigkeitOptionen;
    protected readonly zertifizierungstypOptionen = Object.entries(zertifizierungstyp).map(([key, label]) => ({
        label,
        value: key as ZertifizierungstypEnum
    }));
    visible: boolean = false;
    kurs: KursInfoVO = {};
    kursTeilnehmer: KursInfoTeilnehmerVO;

    istZertifizierung: boolean = false;
    istRezertifizierung: boolean = false;

    zertifizierung: string[] = [zertifizierungstyp.ZERTIFIZIERUNG];
    rezertifizierung: string[] = [zertifizierungstyp.REZERTIFIZIERUNG];

    selectedTyp: any;

    zeigeGutachtertaetigkeiten: boolean = false;
    isAUVA: boolean = false;

    formular = this.formbuilder.group({
        zertifizierungstyp: [null, Validators.required],
        gutachterTaetigkeit: [[]],
        bestaetigungAGB: [false, Validators.requiredTrue],
        bestaetigungDatenschutz: [false, Validators.requiredTrue],
        bestaetigungTraeger: [false]
    });

    constructor(private formbuilder: FormBuilder,
                private teilnehmerService: TeilnehmerApiService,
                private kursAnmeldungService: KursanmeldungApiService,
                private cdr: ChangeDetectorRef) {
    }

    anmeldungSpeichern() {
        const formValue = this.formular.value;

        let zertifizierungsTypValue: KursInfoTeilnehmerVO.ZertifizierungstypEnum;

        if (formValue.zertifizierungstyp! === zertifizierungstyp.ZERTIFIZIERUNG) {
            zertifizierungsTypValue = KursInfoTeilnehmerVO.ZertifizierungstypEnum.ZERTIFIZIERUNG;
        } else if (formValue.zertifizierungstyp! === zertifizierungstyp.REZERTIFIZIERUNG) {
            zertifizierungsTypValue = KursInfoTeilnehmerVO.ZertifizierungstypEnum.REZERTIFIZIERUNG;
        } else {
            zertifizierungsTypValue = formValue.zertifizierungstyp!;
        }

        this.kursTeilnehmer = {
            zertifizierungstyp: zertifizierungsTypValue,
            kursGutachterTaetigkeit: formValue.gutachterTaetigkeit as any,
            kurs: this.kurs,
            bestaetigungAGB: formValue.bestaetigungAGB!,
            bestaetigungDatenschutz: formValue.bestaetigungDatenschutz!,
            bestaetigungTraeger: formValue.bestaetigungTraeger!
        };

        this.kursAnmeldungService.erstelleKursTeilnehmer(this.kursTeilnehmer).subscribe(data => {
            this.visible = false;
            this.hideAnmeldenBtn.emit(data.kurs);
        });
    }

    openOverlay(kurs: KursInfoVO, teilnehmer: TeilnehmerVO) {
        this.kurs = kurs;
        this.visible = true;

        if (this.kurs.typ === "ZERT_GUTACHTUNG_AUVA"
            || this.kurs.typ === "ZERT_PENSION"
            || this.kurs.typ === "ZERT_PFLEGEGELD"
            || this.kurs.typ === "ZERT_PFLEGEGELD_KINDER") {
            this.istZertifizierung = true;
            this.selectedTyp = zertifizierungstyp.ZERTIFIZIERUNG;
        } else if (this.kurs.typ === "REZERT_PENSION" || this.kurs.typ === "REZERT_PFLEGEGELD") {
            this.selectedTyp = zertifizierungstyp.REZERTIFIZIERUNG;
            this.istRezertifizierung = true;
        } else {
            this.istZertifizierung = false;
            this.istRezertifizierung = false;
        }

        if (this.kurs.typ === "ZERT_GUTACHTUNG_AUVA") {
            this.isAUVA = true;
            this.formular.controls['bestaetigungTraeger'].addValidators(Validators.requiredTrue);
        }
        else {
            this.isAUVA = false;
        }

        if (this.kurs.typ === "ZERT_PENSION" || this.kurs.typ === "REZERT_PENSION" || this.kurs.typ === "REZERT_PENSION_PSYCHIATRIE") {
            this.zeigeGutachtertaetigkeiten = true;

            this.formular.controls['gutachterTaetigkeit'].setValue(teilnehmer.gutachterTaetigkeiten as any);
            this.formular.controls['gutachterTaetigkeit'].addValidators(Validators.required);
            this.formular.controls['gutachterTaetigkeit'].updateValueAndValidity();
        } else {
            this.zeigeGutachtertaetigkeiten = false;
        }
        this.cdr.detectChanges();
    }

    closeOverlay() {
        this.visible = false;
    }


    titel(typ: TypEnum) {
        return kursTitelMap[typ];
    }
}
